import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import util from '@/libs/util'
import ViewUI from 'view-design'
// import VueQriously from 'vue-qriously'
import 'view-design/dist/styles/iview.css'
// import VideoPlayer from 'vue-video-player'
// import 'vue-video-player/src/custom-theme.css'
// import 'video.js/dist/lang/zh-CN'
// import 'video.js/dist/video-js.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill';
//import XbzFrontCompilb from 'xbz-front-compilb';
//Vue.use(XbzFrontCompilb);
import { getRequest, postRequest, postRequestApplication, getXBZRequest,getTKRequest,postTKRequest } from '@/libs/axios'
;(function(win) {
  var tid
  function refreshRem() {
    let designSize = 1920 // 设计图尺寸
    let html = document.documentElement
    let wW = html.clientWidth // 窗口宽度
    // 设置最小rem值
    if (wW > 1500) {
      // if (wW > 1000) {
      var rem = (wW * 100) / designSize
      // console.log('wW>1000',rem)
    } else {
      rem = 80
      // rem = 50
      // console.log('wW<1000',rem)
    }
    document.documentElement.style.fontSize = rem + 'px'
  }

  win.addEventListener(
    'resize',
    function() {
      // window.history.go(0)
      clearTimeout(tid)
      tid = setTimeout(refreshRem, 300)
    },
    false
  )
  win.addEventListener(
    'pageshow',
    function(e) {
      if (e.persisted) {
        clearTimeout(tid)
        tid = setTimeout(refreshRem, 300)
      }
    },
    false
  )
  refreshRem()
})(window)

Vue.config.productionTip = false
Vue.prototype.$util = util
// Vue.use(VideoPlayer)
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
// use
Vue.use(mavonEditor)
Vue.use(ViewUI)
Vue.use(ElementUI)
// Vue.use(VueQriously);
/* eslint-disable no-new */

// 异常监控
// import xbzUtil from 'xbz-front-compilb/src/libs/util.js';
// Vue.config.errorHandler = function (err, vm, info) {
//     let userInfo = util.localGet('userInfo');
//     let systemInfo = xbzUtil._handleBroInfo();
//     let errorObj = {
//         bizType: 'ErrorTrack',
//         logType: 'Error',
//         msg: {
//             systemType: 'xbzStudentsWeb',
//             userId: userInfo.id,
//             username: userInfo.username,
//             errorText: err.stack.toString(),
//             errorTime: util.dateFormat(new Date()),
//             errorVueInfo: info,
//             browserInfo: systemInfo.broName,
//             operatingSystem: systemInfo.operatingSystem,
//         },
//     };
//     // window.btoa(unescape(encodeURIComponent(JSON.stringify(errorObj))))
//     new Image().src = `http://39.102.55.146:9001/error?info=${ window.btoa(encodeURIComponent(JSON.stringify(errorObj))) }`;
// }
// 挂载全局使用的方法
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.postRequestApplication = postRequestApplication;
Vue.prototype.getXBZRequest = getXBZRequest;
Vue.prototype.getTKRequest = getTKRequest;
Vue.prototype.postTKRequest = postTKRequest;
Vue.filter('dateFormat', function(originVal) {
  const dt = new Date(originVal)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  data: {
    currentPageName: ''
  },
  mounted() {
    // 初始化菜单
    util.initRouter(this)
    // // 初始化全局数据字典
    // dictUtil.initDictData(this)
    this.currentPageName = this.$route.name
    // 显示打开的页面的列表
    this.$store.commit('setOpenedList')
    this.$store.commit('initCachepage')
  }
})



// WEBPACK FOOTER //
// ./src/main.js